__turbopack_context__.v({
  "banner": "styles-module__J_ojDG__banner",
});
